<template>
  <div class="view-138">
    <div class="view-139">
      <div class="text-199 fontawesome5free-solid-normal-black-20px"></div>
      <div class="text-200 poppins-semi-bold-thunder-20px">Уроки</div>
      <teacher22 />
    </div>
  </div>
</template>

<script>
import Teacher22 from "./Teacher22";
export default {
  name: "View652",
  components: {
    Teacher22,
  },
};
</script>

<style>
.view-138,
.view-140,
.view-142 {
  align-items: center;
  display: flex;
  width: 122px;
}

.view-139,
.view-141,
.view-143 {
  height: 30px;
  position: relative;
  width: 126px;
}

.text-199,
.text-212,
.text-224 {
  left: 112px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 10px);
  white-space: nowrap;
}

.text-200,
.text-213,
.text-225 {
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}
</style>
